<div class="job-filter-panel">
    <div class="filter-header-panel">
        <div class="filter-header-panel-title">
            <gsp-button
                id="close-button"
                [type]="ButtonType.Icon"
                [iconClass]="'icon_line_close_24 i24'"
                (click)="close()"
            ></gsp-button>
            <h2 class="filter-title">{{ filterTitle | translate }}</h2>
        </div>
        <gsp-button
            id="close-button"
            class="clear-filter-btn"
            [type]="ButtonType.Default"
            [disabled]="!isFilterApplied"
            [class.active]="isFilterApplied"
            [text]="'TCW_Clear_Filters' | translate"
            (click)="clear()"
        ></gsp-button>
    </div>
    <div class="filter-body">
        <custom-scroll class="height-full">
            <div class="filter-panel-fields">
                <ng-template #renderFilterField let-field>
                    <ng-container [ngSwitch]="field.type">
                        <!-- Date Field -->
                        <ng-container *ngSwitchCase="'date'">
                            <div class="filter-field">
                                <ng-container *ngIf="field.label">
                                    <label [for]="field.id">{{ field.label }}</label>
                                </ng-container>
                                <date-picker
                                    [id]="field.id"
                                    placeholder="{{ field.placeholder }}"
                                    [(ngModel)]="values[field.id]"
                                    [minDate]="field.minDate"
                                    [maxDate]="field.maxDate"
                                    (ngModelChange)="onFieldChange(field.id, $event)"
                                ></date-picker>
                            </div>
                        </ng-container>
                        <!-- User Field -->
                        <ng-container *ngSwitchCase="'user'">
                            <div class="filter-field">
                                <ng-container *ngIf="field.label">
                                    <label [for]="field.id">{{ field.label }}</label>
                                </ng-container>
                                <user-filter
                                    class="tag-input-alternative"
                                    [id]="field.id"
                                    [placeholder]="field.placeholder"
                                    [allUsers]="field.users"
                                    [(selectedUsers)]="values[field.id]"
                                    (selectedUsersChange)="onFieldChange(field.id, $event)"
                                ></user-filter>
                            </div>
                        </ng-container>
                        <!-- Dropdown Field -->
                        <ng-container *ngSwitchCase="'dropdown'">
                            <div class="filter-field">
                                <ng-container *ngIf="field.label">
                                    <label [for]="field.id">{{ field.label }}</label>
                                </ng-container>
                                <gsp-dropdown
                                    [id]="field.id"
                                    [multiPlaceholder]="field.placeholder"
                                    [textField]="field.textField"
                                    [options]="field.options"
                                    [multiple]="field.multiple"
                                    [(ngModel)]="values[field.id]"
                                    (ngModelChange)="onFieldChange(field.id, $event)"
                                ></gsp-dropdown>
                            </div>
                        </ng-container>
                        <!-- Chip Filter Field -->
                        <ng-container *ngSwitchCase="'chipFilter'">
                            <div class="filter-field">
                                <ng-container *ngIf="field.label">
                                    <label [for]="field.id">{{ field.label }}</label>
                                </ng-container>
                                <chip-filter
                                    [id]="field.id"
                                    [placeholder]="field.placeholder"
                                    [selectable]="true"
                                    [multiInputMode]="true"
                                    [canCreateTags]="false"
                                    [editable]="true"
                                    [class]="'tag-input-alternative'"
                                    [selectedChips]="values[field.id]"
                                    [allChips]="field.options"
                                    [caseSensitive]="false"
                                    (addChipEvent)="addChip(field.id, $event)"
                                    (removeChipEvent)="removeChipFromField(field.id, $event)"
                                ></chip-filter>
                            </div>
                        </ng-container>
                    </ng-container>
                </ng-template>

                <ng-container *ngFor="let field of fields">
                    <ng-container *ngIf="field.type !== 'group'; else groupField">
                        <ng-container
                            *ngTemplateOutlet="renderFilterField; context: { $implicit: field }"
                        ></ng-container>
                    </ng-container>
                    <ng-template #groupField>
                        <div class="filter-group-field">
                            <label>{{ field.label }}</label>
                            <div class="filter-group-fields">
                                <ng-container *ngFor="let childField of field.fields">
                                    <ng-container
                                        *ngTemplateOutlet="renderFilterField; context: { $implicit: childField }"
                                    ></ng-container>
                                </ng-container>
                            </div>
                        </div>
                    </ng-template>
                </ng-container>
            </div>
        </custom-scroll>
    </div>
</div>
